// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import _ from 'lodash';
import { format, parse } from 'date-fns';
import DateFNSPT from 'date-fns/locale/pt';
// local
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// lib
import { diffBetweenDates, PRECISION, timezoneDate } from 'app/lib/dateHelper';
// import { fromUTC } from 'app/lib/helper';
// consts
// import { CYLINDER_PRESSURE_MAP } from 'salvus-shared/consts/cylinder';
// css
import './TableOxigen.scss';

const DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';

class TableOxigen extends Component {
    renderEmpty = () => <EmptyList emptyMessage="Nenhum histórico de consumo computado." />;

    renderTable(data) {
        // , cylinderSize) {
        // const { v: cylinderVolumeMax, p: cylinderPressureMax } = CYLINDER_PRESSURE_MAP[cylinderSize];
        return (
            <Table id="oxigen-history">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>INÍCIO</Table.HeaderCell>
                        <Table.HeaderCell>TÉRMINIO</Table.HeaderCell>
                        <Table.HeaderCell>TEMPO TOTAL</Table.HeaderCell>
                        <Table.HeaderCell>CONSUMO TOTAL (m³)</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {_.map(data, row => {
                        const stAt = timezoneDate(new Date(row.startedAt), 'America/Recife');
                        const edAt = timezoneDate(new Date(row.endedAt), 'America/Recife');
                        const startedAt = row.startedAt ? format(stAt, DATE_FORMAT, { locale: DateFNSPT }) : '-';
                        const endedAt = row.endedAt ? format(edAt, DATE_FORMAT, { locale: DateFNSPT }) : '-';
                        const totalTime = row.startedAt && row.endedAt ? diffBetweenDates(parse(row.endedAt), parse(row.startedAt), PRECISION.SECOND) : '-';
                        // const totalUsed = (row.totalUsed * cylinderVolumeMax) / cylinderPressureMax / 1000;
                        return (
                            <Table.Row key={_.uniqueId('oxigen_history_')}>
                                <Table.Cell>{startedAt}</Table.Cell>
                                <Table.Cell>{endedAt}</Table.Cell>
                                <Table.Cell>{totalTime}</Table.Cell>
                                <Table.Cell>
                                    {row.totalUsed.toFixed(2)}
                                    m³
                                </Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        );
    }

    render() {
        const { data, cylinderSize } = this.props;
        return _.isEmpty(data) ? this.renderEmpty() : this.renderTable(data, cylinderSize);
    }
}

TableOxigen.propTypes = {
    data: PropTypes.array,
    cylinderSize: PropTypes.number,
};

export default TableOxigen;
